import "./CommandShortcut.css";

export function CommandShortcut({ children }) {
	return (
		<span className="command-shortcut">{children}</span>
	);
}